export default __webpack_public_path__ + "static/media/GiraffePage1.74c24fe7.txt";